import Vue from 'vue'
import Router from 'vue-router'
import Authorized from '@/components/Authorized'
import TagTemplate from '@/components/TagTemplate'
import Armstrong from '@/components/ArmstrongTemplate'
import MessageTemplate from '@/components/MessageTemplate'
import RedirectTemplate from '@/components/RedirectTemplate'
import NotFound from '@/components/NotFound'
import Test from '@/components/Test'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home'
    },
    {
      path: '/auth',
      name: 'authorized',
      component: Authorized
    },
    {
      path: '/tag',
      name: 'Tag',
      component: TagTemplate
    },
    {
      path: '/armstrong',
      name: 'Armstrong',
      component: Armstrong
    },
    {
      path: '/messageTemplate',
      name: 'MessageTemplate',
      component: MessageTemplate
    },
    {
      path: '/redirect/:id',
      name: 'RedirectTemplate',
      component: RedirectTemplate,
      beforeEnter: (to, from, next) => {
        if (/^\d+$/.test(to.params.id)) {
          next()
        } else {
          next('/not-found')
        }
      }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/not-found'
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    }
  ]
})

// 用於檢查和清理 URL 參數的函數
function sanitizeUrlParams (params) {
  const sanitized = {}
  for (const [key, value] of Object.entries(params)) {
    // 移除任何包含 '../' 或 '..\\' 的參數
    if (typeof value === 'string' && !value.includes('../') && !value.includes('..\\')) {
      sanitized[key] = value
    }
  }
  return sanitized
}

// // 全局導航守衛
router.beforeEach((to, from, next) => {
  // only for testing
  console.log(to.query)
  console.log(`path: ${to.path}`)
  // if ((Object.keys(to.query).length !== 0)) {
  //   next({
  //     path: 'test',
  //     query: null
  //   })
  //   return
  // }

  // 檢查並清理 URL 參數
  const sanitizedQuery = sanitizeUrlParams(to.query)

  // 如果參數被清理（即有參數被移除），則重定向到清理後的 URL
  if (Object.keys(sanitizedQuery).length !== Object.keys(to.query).length) {
    next({
      path: to.path,
      query: sanitizedQuery,
      replace: true // 替換當前的歷史記錄，而不是添加新的
    })
    return
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('user-token')) {
      next({
        path: '/auth',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.onError((error) => {
  console.error('路由错误:', error)
  router.push('/not-found')
})

export default router
